import { render, staticRenderFns } from "./mdl-esito.vue?vue&type=template&id=2a036ba0&"
import script from "./mdl-esito.vue?vue&type=script&lang=js&"
export * from "./mdl-esito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports